import MissingEnedisNeededFields from '@/containers/SubscriptionFormPageNew/Components/ElectricityMeter/Fields/MissingEnedisNeededFields'
import EnedisAuth from '@/containers/SubscriptionFormPageNew/Components/ElectricityMeter/Fields/EnedisAuth'
import MeterInformation from '@/containers/SubscriptionFormPageNew/Components/ElectricityMeter/Fields/MeterInformation'
import MeterInput from '@/containers/SubscriptionFormPageNew/Components/ElectricityMeter/Fields/MeterInput/MeterInput'
import useElectricityMeterListener from '@/containers/SubscriptionFormPageNew/Components/ElectricityMeter/useElectricityMeterListener'
import useElectricityMeterSave from '@/containers/SubscriptionFormPageNew/Components/ElectricityMeter/useElectricityMeterSave'
import PdlSearchModal from '@/containers/SubscriptionFormPageNew/Components/ElectricityMeter/PdlSearch/PdlSearchModal'

// Note: the per-module 'Save' button has been removed. Saving is now driven by
// the global ClientTopHeader button which dispatches CLIENT_TAB_SAVE_ALL.
// useElectricityMeterSave is still consumed to derive `country` for conditional
// rendering of <MeterInformation />.
const ElectricityMeter = () => {
  useElectricityMeterListener()
  const { country } = useElectricityMeterSave()

  return (
    <>
      <MeterInput />
      <EnedisAuth />
      <MissingEnedisNeededFields />
      <MeterInformation type='client' hidden={country !== 'fr'} />
      <PdlSearchModal />
    </>
  )
}

export default ElectricityMeter
